const languages = ["ru", "en", "ar", "es", "fa", "kz", "pt"];
const modules = [
  "Auth",
  "Services",
  "Studies",
  "Viewer",
  "General",
  "Community",
  "Edu",
  "Subs",
  "LK",
  "Verify",
];

const translations = {};

languages.forEach((lang) => {
  translations[lang] = {};

  modules.forEach((module) => {
    translations[lang][module] =
      require(`./${lang}${lang.toUpperCase()}/${module}.js`).default;
  });
});

const titles = require("./Titles/index.js").default;

const result = Object.keys(translations).reduce((acc, lang) => {
  acc[lang] = Object.values(translations[lang]).reduce(
    (merged, module) => ({
      ...merged,
      ...module,
      ...titles,
    }),
    {}
  );

  return acc;
}, {});

export default result;
